import { render, staticRenderFns } from "./PastDepartmentsForm.vue?vue&type=template&id=3ebeed74&"
import script from "./PastDepartmentsForm.vue?vue&type=script&lang=js&"
export * from "./PastDepartmentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports